import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Report } from '../../../report';
import { GetTempTransactionsService } from '../../../services/biller/get-temp-transactions.service';
import * as moment from 'moment';
import { dataTableFormatter } from './helper';
@Component({
  selector: 'app-temp-transactions',
  templateUrl: './temp-transactions.component.html',
  styleUrls: ['./temp-transactions.component.scss']
})
export class TempTransactionsComponent implements OnInit {
  loading = false;
  gatData:any[] = [];
  totalNumberOfRecords: number = 0;
  requestBody: Report = {};
  itemsPerPage: number = 10;

  displayTableColumns: { [key: string]: string } = {
    referenceNumber: 'Reference Number',
    status: 'Status',
    service: 'Service',
    type: 'Service Type',
    merchant: 'Merchant',
    subTotal: 'SubTotal',
    totalAmount: 'Total Amount',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    userRole : 'User Type',
    source : 'Source',
    phone : 'User Phone',
    receiver : 'Receiver'
  };

  properties = [
    'referenceNumber',
    "totalAmount",
    'service',
    'type',
    'merchant',
    'status',
    'subTotal',
    'createdAt',
    'updatedAt',
    'userRole',
    'source',
    'phone',
    'receiver'
  ];

  selectFilters = [
    {
      filterFieldName: 'type',
      filterDisplayName: 'Type',
      filterOptions: [
        { key: 'inquirable', value: 'inquirable' },
        { key: 'none inquirable', value: 'none inquirable' },
      ],
      defaultValue: null,
    },
    {
      filterFieldName: "status",
      filterDisplayName: "Status",
      defaultValue: "",
      filterOptions: [
        { key: "Show All", value: null },
        { key: "New", value: "NEW" },
        { key: "Paid", value: "PAID" },
        { key: "Failed", value: "FAILED" },
      ]
    }
  ];


  constructor(
    public tempTransactionsReport: GetTempTransactionsService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(){
      this.tempTransactionsReport.activateLoader();
      this.prepareColumnsAndProperties();
      this.selectFilters.splice(0,1);
    this.requestBody.filterOptions = {};
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async updateTable() {
    this.tempTransactionsReport.activateLoader();
    this.tempTransactionsReport.loader().subscribe(val => (this.loading = val));

    const todayDate = new Date();
    const forceTodayDate = !this.requestBody['filterOptions']['createdAt'] ? true : false;
      // @ts-ignore
      let { startDate, endDate } = forceTodayDate
        ? {
            startDate: moment(todayDate).format('YYYY-MM-DD') + ' 00:00:00',
            endDate: moment(todayDate).format('YYYY-MM-DD') + ' 23:59:59',
          }
        : this.requestBody['filterOptions']['createdAt'];

      const from = moment(startDate).format('YYYY-MM-DD') + " 00:00:00";
      const to = moment(endDate).format('YYYY-MM-DD') + " 23:59:59";


      this.requestBody.filterOptions.createdAt = {
         // @ts-ignore
        startDate,
        endDate,
        from,
        to
      };

    try{
      this.tempTransactionsReport.setParams(this.requestBody);
      const responseData = await this.tempTransactionsReport.make();

      this.totalNumberOfRecords = responseData.totalNumberOfRows;
      this.gatData = responseData.result.map(dataTableFormatter)
      this.cdr.detectChanges();
    }catch(error){
      console.log(error);
    }
  }

  getCurrentPage(event: any) {
    if (event && Object.keys(event).length) {
      console.log("filter should not be null");
      this.requestBody.filterOptions = event;
    } else {
      console.log("filter should be null");
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  mapRecordsToFilterOptions(Records: { id: string; name: string }[]) {
    return Records.map((rec) => {
      return { key: rec.name, value: rec.id };
    });
  }
  prepareColumnsAndProperties() {
    const merchantProperties = [
      'referenceNumber',
      'status',
      'service',
      'type',
      'merchant',
      'subTotal',
      "totalAmount",
      'createdAt',
      'updatedAt',
      'userRole',
      'source',
      'phone',
      'receiver'
    ];
    let merchantReportColumns = merchantProperties.map((res) => {
      return { [res]: this.displayTableColumns[res] };
    });
    let merchantReportDisplayColumns = merchantReportColumns.reduce(function (
      result,
      item
    ) {
      var key = Object.keys(item)[0];
      result[key] = item[key];
      return result;
    },
    {});
    this.displayTableColumns = merchantReportDisplayColumns;
    this.properties = merchantProperties;
  }
  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
  }
  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
    }
    await this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
  }

}
